import { ACTION_TYPE } from "../../Services/index";
export const initialState = {
	comment: [],
};

export const postCommentReducer = (state = initialState, action) => {
	console.log("likes", action.type);
	console.log("likes data", action.payload);

	switch (action.type) {
		case ACTION_TYPE.POSTCOMMENT:
			return {
				...state,
				comment: action.payload?.data,
			};

		default:
			return state;
	}
};
